export const CROP_TYPES = [
  {
    name: "Wheat",
    value: 1
  },
  {
    name: "Barley",
    value: 2
  },
  {
    name: "Maize",
    value: 3
  },
  {
    name: "Oats",
    value: 4
  },
  {
    name: "Rice",
    value: 5
  },
  {
    name: "Sorghum",
    value: 6
  },
  {
    name: "Triticale",
    value: 7
  },
  {
    name: "Other Cereals",
    value: 8
  },
  {
    name: "Pulses",
    value: 9
  },
  {
    name: "Tuber and Roots",
    value: 10
  },
  {
    name: "Peanuts",
    value: 11
  },
  {
    name: "Sugar Cane",
    value: 12
  },
  {
    name: "Cotton",
    value: 13
  },
  {
    name: "Hops",
    value: 14
  },
  {
    name: "Oilseeds",
    value: 15
  },
  {
    name: "Forage Crops",
    value: 16
  }
]

export const CROP_PRODUCTION_SYSTEMS = [
  {
    name: "Non-irrigated crop",
    value: 1
  },
  {
    name: "Irrigated crop",
    value: 2
  },
  {
    name: "Sugar cane",
    value: 3
  },
  {
    name: "Cotton",
    value: 4
  },
  {
    name: "Horticulture",
    value: 5
  }
]
